/**
 * @file lib/utils/uuid.ts
 * @description UUID生成ユーティリティ
 * @author GFTD Co., Ltd.
 */

/**
 * シンプルなUUID v4生成（ブラウザ・Node.js両対応）
 */
export function generateUUID(): string {
  // モダンブラウザのcrypto.randomUUID()を優先使用
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  
  // フォールバック: RFC4122準拠のUUID v4生成
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

/**
 * 短縮UUID生成（8文字、英数字のみ）
 */
export function generateShortUUID(): string {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''
  for (let i = 0; i < 8; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}

/**
 * アクター用のリポジトリ名生成
 * @param actorName 人間が読める名前
 * @returns UUID付きのリポジトリ名
 */
export function generateRepositoryName(actorName: string): string {
  const uuid = generateShortUUID()
  const safeName = actorName
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, '-')  // 英数字とハイフンのみ
    .replace(/-+/g, '-')          // 連続するハイフンを1つに
    .replace(/^-|-$/g, '')        // 先頭・末尾のハイフンを削除
    .substring(0, 20)             // 20文字まで
  
  return `${safeName}-${uuid}`
}

/**
 * タイムスタンプ付きのUUID生成
 */
export function generateTimestampUUID(): string {
  const timestamp = Date.now().toString(36)
  const randomPart = generateShortUUID()
  return `${timestamp}-${randomPart}`
}

/**
 * UUID検証
 */
export function isValidUUID(uuid: string): boolean {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
  return uuidRegex.test(uuid)
}

/**
 * 短縮UUID検証
 */
export function isValidShortUUID(uuid: string): boolean {
  const shortUuidRegex = /^[a-z0-9]{8}$/
  return shortUuidRegex.test(uuid)
} 